
import ServicePageLayout from "@/components/ServicePageLayout";
import StyledBulletPoint from "@/components/StyledBulletPoint";
import { Button } from "@/components/ui/button";

const Cercle = () => {
  const openCalendly = () => {
    window.open("https://calendly.com/meneora/cercle-pro", "_blank");
  };

  return (
    <ServicePageLayout
      heroImage="/lovable-uploads/35004b11-ebbc-4567-8bfd-dbc23472206d.png"
      heroAlt="Cercle de thérapeutes"
      heroTitle="Cercle de guérison & transmission entre praticiens"
      heroText="Un espace sacré pour se déposer, se relier, vibrer ensemble."
    >
      {/* Pour qui section */}
      <section className="mb-16 reveal-on-scroll">
        <div className="max-w-4xl mx-auto">
          <h2 className="section-title text-center mb-8">Pour qui ?</h2>
          <div className="space-y-3 mt-8">
            <StyledBulletPoint>Tu accompagnes mais tu portes trop</StyledBulletPoint>
            <StyledBulletPoint>Tu manques d'un espace pour déposer</StyledBulletPoint>
            <StyledBulletPoint>Tu as besoin de soutien vibratoire entre pairs</StyledBulletPoint>
          </div>
        </div>
      </section>

      {/* Déroulé section */}
      <section className="mb-16 reveal-on-scroll">
        <div className="max-w-4xl mx-auto">
          <h2 className="section-title text-center mb-6">Se reconnecter à sa fréquence</h2>
          <p className="text-xl text-center mb-8 text-foreground/80">
            Ouverture du cercle – partages – chants – silences – clôture. Aucun jugement. Aucune obligation de parole.
          </p>
        </div>
      </section>

      {/* Modalités section */}
      <section className="mb-16 reveal-on-scroll">
        <div className="max-w-4xl mx-auto">
          <h2 className="section-title text-center mb-6">Modalités</h2>
          <div className="space-y-3 max-w-md mx-auto">
            <StyledBulletPoint>Durée : 1h30</StyledBulletPoint>
            <StyledBulletPoint>Tarif : 20 €</StyledBulletPoint>
            <StyledBulletPoint>En visio ou présentiel à Étampes</StyledBulletPoint>
          </div>
        </div>
      </section>

      {/* Réservation section */}
      <section className="bg-accent/10 p-8 rounded-lg reveal-on-scroll">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="section-title mb-4">S'inscrire au prochain cercle</h2>
          <Button size="lg" onClick={openCalendly}>
            Réserver
          </Button>
        </div>
      </section>
    </ServicePageLayout>
  );
};

export default Cercle;
